import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ErrorMessage, Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import React from 'react';
import withRepeatField from '../RepeatFormFieldsHOC';
const FieldWrapper = _styled("div", {
  target: "e71nu6s0",
  label: "FieldWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "qxh7fn",
  styles: "width:500px;"
} : {
  name: "qxh7fn",
  styles: "width:500px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const TextInput = _ref => {
  let {
    defaultValue = '',
    placeholder,
    onChange,
    fieldName,
    validate,
    type = 'text'
  } = _ref;
  const handleChange = e => {
    onChange(e.target.value);
  };
  return /*#__PURE__*/React.createElement(FieldWrapper, null, /*#__PURE__*/React.createElement(Field, {
    name: fieldName,
    validate: validate,
    defaultValue: defaultValue
  }, _ref2 => {
    let {
      fieldProps,
      error
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Textfield, _extends({}, fieldProps, {
      appearance: "standard",
      label: "Standard",
      placeholder: placeholder,
      value: defaultValue,
      testId: "partnerFormTextInput",
      type: type,
      onChange: e => {
        handleChange(e);
      }
    })), error && /*#__PURE__*/React.createElement(ErrorMessage, null, error));
  }));
};
export const RepeatingTextInput = withRepeatField(TextInput);